import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { AdminsService } from 'src/app/_services/admins/admins.service';

@Component({
  selector: 'app-workers',
  templateUrl: './workers.component.html',
  styleUrls: ['./workers.component.css']
})
export class WorkersComponent implements OnInit {
  @ViewChild('closebutton') closebutton: any;
   showEdit: Array<boolean> = [];
  showSide: string = '';
  products!: Array<object>;
  selectedProducts: Array<object> = [];
  headerData: Array<any> = [];
  loading: boolean = true;
  search:boolean=false;
  workerId:any;
  subscriptions:Subscription[] = [];
  listDropDown:Array<object>=[{name:'All'},{name:'Today'},{name:'Last Week'},{name:'This month'},{name:'This year'}]

  constructor( public _adminservices:AdminsService ,public router: Router,private messageService: MessageService,) { }
////////////////////////////////////////////////
globalFilter: string = '';

  currentPage: number = 0;
 @ViewChild('dt2', { static: false }) dt2?: any;
  tableReady = false;

  onPageChange(event: any) {
    this.currentPage = event.first;
    console.log(this.currentPage)
    localStorage.setItem('workerPage', this.currentPage.toString());
  }


  ngOnInit() {
    const savedPage = localStorage.getItem('workerPage');
    this.currentPage = savedPage ? +savedPage : 0;
    console.log(this.currentPage)
    ////////////////////////////////////////////

    // this.getAllworkers(  )

         //////////////////////////////////////////////////
         if(localStorage.getItem('pageNoWork')){
    
          let numberF=Number(localStorage.getItem('firstWork'))
    
          let numberR=Number(localStorage.getItem('rowsWork'))
          let number=Number(localStorage.getItem('pageNoWork'))
    
         
          this.first=numberF
          this.rows=numberR
          this.pageNumber=number
    
          this.getAllworkers();
    
    
          
        }else{
          this.getAllworkers();
    
    
        }
        //////////////////////////////////////////////////
    this.checkRole();
  }

   /**
   * selectedfromDropDown
   * @param $event string
   * @returns void
   */
  selectedfromDropDown(value:any){

    this.Date=value.name;
    this.getAllworkers()
  }
  /**
   * addItem
   * @param value string
   * @returns void
   */
  addItem(value: string): void {
    this.showSide = value
  }


  statusTenant:any=""
  pageNumber=1;
  pagesize=10;
  totalofPages=0;
  first: number = 1;
  rows: number = 10;
  disablenext=false;
  disableperv=false;

workers:any[]=[]
totalRecords=0
tiggerPageChange(event: any) {

  this.first = event.first;
  this.rows = event.rows;
  let calcPageNumber = Math.floor(this.first / this.rows) + 1;
  this.pageNumber = calcPageNumber;
      this.getAllworkers(  )


      localStorage.setItem('firstWork',this.first.toString())
      localStorage.setItem('pageNoWork',this.pageNumber.toString())
  
  
      localStorage.setItem('rowsWork',this.rows.toString())


     }





  numberworkers=0;
  Date:any="All"
   getAllworkers(  ) {
    this.workers=[]
    this.numberworkers=0
    this.subscriptions.push(this._adminservices.GetAllWorkers( 1,20000,this.searchText).subscribe((res:any) => {
      this.workers = res["data"];
      this.totalRecords=res["totalRecords"]

      // this.numberworkers = this.workers.length;
      this.numberworkers = this.totalRecords;

      this.totalofPages=res["totalPages"]
//////////////////////
      const savedPage = localStorage.getItem('workerPage');
      this.currentPage = savedPage ? +savedPage : 0;
      console.log(this.currentPage) 
      this.tableReady = true;
//////////////////////////

     }, (error) => {
       console.error('Error fetching owners:', error);
    }));

  }
  detailperson(event:any,id: any): void {
    this.showEdit=[]
    event.stopPropagation()

    this.showEdit[id] == true ? this.showEdit[id] = false : this.showEdit[id] = true



   }
   hidecard( ){
    this.showEdit=[]

 }
 deleteworker() {

  this.subscriptions.push(this._adminservices.DeleteWorker(this.workerId).subscribe(
    (res: any) => {
      this.closebutton.nativeElement.click();
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: `${res.message}`,
      });

      this.getAllworkers();
    },
    (error) => {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: `${error.error.message[0]}`,
      });
    }
  ));

}
workersRole:any
is_Super:any
checkRole(){
  const data = localStorage.getItem("user");
   if (data !== null) {

    let parsedData = JSON.parse(data);
     this.is_Super=parsedData.is_Super
    if(parsedData.is_Super==false) {
for(let i=0; i<parsedData.permissions.length;i++){
  if(parsedData.permissions[i].page_Name=="workers"){
    this.workersRole=parsedData.permissions[i];
  }
}
if(this.workersRole.p_View==false &&this.is_Super==false) {
  this.gotopage( )
}
}


  }
}
gotopage( ){
  let url: string = "unlegal";
    this.router.navigateByUrl(url);
}

searchText: any = '';

searchKey(data: string) {
  this.searchText = data;
  this.getAllworkers();
}
searchTextChange: any;
searchAction(event: KeyboardEvent) {
  if (this.searchText.trim() === '' && (event.key === 'Backspace' || event.key === ' ')) {
    event.preventDefault();
    return;
}
  this.getAllworkers();
}

display = 'none';


deleteModal(id: any) {
  this.display = 'block';
  this.display = 'flex';
  this.workerId = id;
}

onCloseHandled() {
  this.display = 'none';
}


ngOnDestroy() {
  for(let i=0;i<this.subscriptions.length;i++)
  this.subscriptions[i].unsubscribe();
}



////////////////////////


customSort(event: { data: any[], field: string, order: number }) {
  event.data.sort((a, b) => {
    let valueA = a[event.field];
    let valueB = b[event.field];

    console.log("Before Sorting:", valueA, valueB); // Debugging output

    // ✅ Handle null values properly
    if (valueA == null && valueB == null) return 0;
    if (valueA == null) return event.order;  // Null values should appear last in ascending order
    if (valueB == null) return -event.order; // Null values should appear first in descending order

    // ✅ Convert string dates (like "Mar 5, 2025") into Date objects for sorting
    if (this.isValidDate(valueA) && this.isValidDate(valueB)) {
      let dateA = new Date(valueA);
      let dateB = new Date(valueB);
      let result = (dateA.getTime() - dateB.getTime()) * event.order;

      console.log("Sorted Dates:", dateA, dateB, "Result:", result); // Debugging output

      return result;
    }


      // ✅ التحقق مما إذا كانت القيم تواريخ
      if (this.isDate(valueA) && this.isDate(valueB)) {
        return (new Date(valueA).getTime() - new Date(valueB).getTime()) * event.order;
      }


    // ✅ Handle numeric sorting
    if (!isNaN(valueA) && !isNaN(valueB)) {
      return (parseFloat(valueA) - parseFloat(valueB)) * event.order;
    }

    // ✅ Handle text sorting (case insensitive)
    return valueA.toString().localeCompare(valueB.toString(), undefined, { numeric: true }) * event.order;
  });

  console.log("After Sorting:", event.data.map(item => item[event.field])); // Debugging output after sorting
}




// ✅ دالة تتحقق مما إذا كانت القيمة تاريخًا
isDate(value: any): boolean {
  return !isNaN(Date.parse(value));
}
 

isValidDate(dateString: string): boolean {
  return dateString != null && !isNaN(Date.parse(dateString));
}


 statuses = [
  { label: 'Upcoming', value: 'Upcoming' },
  { label: 'Current', value: 'Current' },
  { label: 'Checked Out', value: 'Checked Out' }

];

getSeverity(status: string): string {
  switch (status) {
    case 'Upcoming': return 'rounded-5 px-3 badge Upcoming';
    case 'Current': return 'rounded-5 px-3 badge Current';
    case 'Checked Out': return 'rounded-5 px-3 badge Cancelled';

    case 'Completed': return 'rounded-5 px-3 badge Completed';
    case 'Approved': return 'rounded-5 px-3 badge Approved';
    case 'Cancelled': return 'rounded-5 px-3 badge Cancelled';
    case 'Pending': return 'rounded-5 px-3 badge Pending';
    case 'Rejected': return 'rounded-5 px-3  badge Rejected';
    case 'CheckedOut': return 'rounded-5 px-3  badge Waiting';
    case 'Waiting': return 'rounded-5 px-3  badge Waiting';

    default: return '';
  }
}


}
